import React from "react";

import useRedux from "hooks/useRedux";
import * as actionsGroupList from "./portfolio.duck";
import * as shoppingCartActionsGroupList from "../shoppingCart/shoppingCart.duck";
import * as editorActionsGroupList from "portfolioEntryWizard/portfolioEntry.duck";

import Report from "./components/Reports";

import Heading from "../home/components/Heading";
import Footer from "../home/components/Footer";
import ContentSection from "../home/components/ContentSection";

import ErrorPanel from "../components/ErrorPanel";
import moment from "moment";

import { CircularProgress } from "@material-ui/core";
import { getDateValues } from "portfolioEntryWizard/components/PortfolioValuesNew";

import styled from "styled-components";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

const Content = styled.div`
  height: 100%;
  width: 100%;

  @media screen {
    overflow: auto;
  }
`;

const Main = (props) => {
  const { id } = props.match.params;

  const [{ portfolio }, actions, shoppingCartActions, editorActions] = useRedux(
    actionsGroupList,
    shoppingCartActionsGroupList,
    editorActionsGroupList,
  );

  const [datesAvailable, datesAvailable_set] = React.useState([]);

  React.useEffect(() => {
    const { match } = props;
    const { id, regenerate } = match.params;

    actions.loadPortfolio(id, regenerate === "regenerate");
  }, []);

  React.useEffect(() => {
    if (datesAvailable.length === 0) {
      portfolio &&
        portfolio.portfolio &&
        portfolio.portfolio.data.portfolioValues.forEach((val, index) => {
          var item = getDateValues(val.key);

          var dateItem = {
            ...item,
            key: val.key,
            label: moment(new Date(+item.year, +(item.month - 1))).format(
              "MMM",
            ),
          };

          datesAvailable.push(dateItem);
        });

      datesAvailable_set([...datesAvailable]);
    }
  }, [portfolio]);

  const isGuid = id.indexOf("-") > 0;

  return (
    <div>
      <Heading maxWidth={1400} {...props} showButtons={true} />
      <Page>
        <Content>
          <ContentSection maxWidth={1400}>
            {portfolio.loading && (
              <div style={{ textAlign: "center", margin: 60 }}>
                <div>
                  <CircularProgress />
                </div>
                <div>Loading...</div>
              </div>
            )}
            {!portfolio.loading && (
              <div>
                {!portfolio.error && (
                  <Report
                    {...{ props, actions }}
                    actions={actions}
                    shoppingCartActions={shoppingCartActions}
                    editorActions={editorActions}
                    portfolio={portfolio}
                    isGuid={isGuid}
                    id={id}
                    datesAvailable={datesAvailable}
                    onDateRangeChange={(
                      startMonth,
                      startYear,
                      endMonth,
                      endYear,
                    ) => {
                      actions.loadPortfolioForDateRange(
                        id,
                        startMonth,
                        startYear,
                        endMonth,
                        endYear,
                      );
                    }}
                  />
                )}
                {portfolio.error && (
                  <div>
                    <ErrorPanel error={portfolio.error} />
                  </div>
                )}
              </div>
            )}
          </ContentSection>
          <Footer />
        </Content>
      </Page>
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/portfolio/Main.js